import type { ComponentType } from 'react';

import type { PageSkill, PageSkillComponentProps, SkillData, SkillResponseSchema, SkillConfirmation } from '../types';

/** Infer skill data from field descriptions and mandatory fields, without repeating its type. */
export const definePageSkill = <const Schema extends SkillResponseSchema | undefined = undefined>(
  skill: {
    type: string;
    description: string;
    responseSchema?: Schema;
    confirmation?: true | SkillConfirmation<keyof SkillData<NoInfer<Schema>> & string>;
  } & (
    | { execute: (skillData: SkillData<NoInfer<Schema>>) => void | Promise<void>; component?: never }
    | { component: ComponentType<PageSkillComponentProps<SkillData<NoInfer<Schema>>>>; execute?: never }
  ),
): PageSkill =>
  // The registry combines different schemas; response validation runs before dispatch.
  skill as PageSkill;
